import { Card, CardContent } from "../components/ui/card";
import * as Icons from "lucide-react";

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#143e6e] mb-4">
              Impressum
            </h1>
            <p className="text-lg text-gray-600">
              Angaben gemäß § 5 TMG
            </p>
          </div>

          {/* Company Information */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <div className="space-y-6">
                <div>
                  <h2 className="text-2xl font-bold text-[#143e6e] mb-4">
                    ReTech IT GbR
                  </h2>
                  <p className="text-gray-700 text-lg">
                    Malik Vijahat Ahmad und Moran Roj Ismaiel
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-3 flex items-center">
                    <Icons.MapPin className="mr-2 text-[#1f7db6]" size={20} />
                    Postanschrift
                  </h3>
                  <p className="text-gray-700 ml-7">
                    Goosmoortwiete 4<br />
                    25474 Bönningstedt
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-3 flex items-center">
                    <Icons.Phone className="mr-2 text-[#1f7db6]" size={20} />
                    Kontakt
                  </h3>
                  <div className="ml-7 space-y-2">
                    <p className="text-gray-700">
                      <span className="font-medium">Telefon:</span>{" "}
                      <a href="tel:017663078464" className="text-[#1f7db6] hover:text-[#143e6e] transition-colors">
                        0176 63078464
                      </a>
                    </p>
                    <p className="text-gray-700">
                      <span className="font-medium">E-Mail:</span>{" "}
                      <a href="mailto:info@retech-it.de" className="text-[#1f7db6] hover:text-[#143e6e] transition-colors">
                        info@retech-it.de
                      </a>
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-3 flex items-center">
                    <Icons.Users className="mr-2 text-[#1f7db6]" size={20} />
                    Vertreten durch
                  </h3>
                  <p className="text-gray-700 ml-7">
                    Malik Vijahat Ahmad und Moran Roj Ismaiel
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Legal Information */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.Scale className="mr-3 text-[#1f7db6]" size={24} />
                Hinweise zur Website
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-3">
                    Information gemäß § 36 VSBG
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Gemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative 
                    Streitbeilegung in Verbrauchersachen) erklärt der Betreiber dieser Website:
                  </p>
                  <p className="text-gray-700 leading-relaxed mt-3 font-medium">
                    Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* EU Platform */}
          <Card className="border-gray-200 shadow-lg bg-blue-50">
            <CardContent className="p-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#1f7db6] rounded-full flex items-center justify-center">
                    <Icons.Info className="text-white" size={24} />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">
                    Hinweis
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Die Plattform der EU zur außergerichtlichen Streitbeilegung finden Sie online unter:{" "}
                    <a 
                      href="https://ec.europa.eu/consumers/odr/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#1f7db6] hover:text-[#143e6e] font-medium underline transition-colors"
                    >
                      https://ec.europa.eu/consumers/odr/
                    </a>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Copyright Notice */}
          <div className="text-center mt-8 text-sm text-gray-600">
            <p>© {new Date().getFullYear()} ReTech IT GbR. Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
